module.exports = require("./../../_gen/starling/geom/Polygon");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/geom/Polygon.js
// module id = 209
// module chunks = 0